import { gateway } from "../../../gateway";
import {
  GetContactsResponse,
  MarkContactAsReadParams,
  MarkContactAsReadResponse,
} from "../_types/internalContacts.types";

export const fetchInternalContacts = async (
  token: string,
): Promise<GetContactsResponse> => {
  const response = await gateway.get("/messages/contacts", {
    params: { pageSize: "9999", page: "1" },
    headers: { Authorization: `${token}` },
  });
  return response.data.data;
};

export const markInternalContactAsRead = async (
  token: string,
  params: MarkContactAsReadParams,
): Promise<MarkContactAsReadResponse> => {
  const response = await gateway.patch("/messages/contacts/read", params, {
    headers: { Authorization: `${token}` },
  });
  return response.data.data;
};
